import {Observable, Subject} from 'rxjs';

import IInteractionPayload from '../Analytics/Interactions/Interfaces/IInteractionPayload';
import ISnapshot           from '../State/Shared/Interfaces/ISnapshot';

import IErrorsPayload from './Interfaces/IErrorsPayload';

class ConsumerOutput {
    public state$: Observable<ISnapshot> = null;
    public interactions$ = new Subject<IInteractionPayload>();
    public errors$ = new Subject<IErrorsPayload>();
}

export default ConsumerOutput;